import { BrowserOptions, ErrorEvent, EventHint } from '@sentry/react';
import { getEnvironment } from 'shared/utils/environment/determineEnvironment';
import { isSentryDebuggingEnabled } from 'shared/utils/environment/variables';

function isProductFruitsError(event: ErrorEvent): boolean {
  return (
    event.request?.url?.includes('productfruits.com') ||
    JSON.stringify(event).includes('productfruits.com')
  );
}

export const getSentryConfig = (
  applicationType: 'React' | 'ServiceWorker',
  version: string
): BrowserOptions => {
  return {
    dsn: 'https://c63f66769a6f478f93949b84ea43edab@o455099.ingest.sentry.io/5446110',
    environment: getEnvironment(),
    debug: isSentryDebuggingEnabled(),
    initialScope: {
      tags: { applicationType },
    },
    release: `react@${version}`,
    enableLogs: true,
    beforeSend: (event: ErrorEvent, hint?: EventHint) => {
      if (isProductFruitsError(event)) {
        return null;
      }
      return event;
    },
  };
};
